import { useEffect, useRef } from 'react';

/**
 * Google Analytics 4 measurement ID — looks like "G-XXXXXXXXXX". Paste yours
 * here (Admin → Data Streams → your web stream) and tracking switches on.
 * Left empty, nothing loads and no requests are made.
 */
export const GA_MEASUREMENT_ID = 'G-G3QMSZ23EL';
declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * The site is a single page app, so gtag's automatic pageview only ever fires
 * once. Auto-send is disabled and a page_view is sent per route instead, which
 * is what makes /how and /contact show up as distinct pages in GA.
 */
export function Analytics({
  pathname
}: {
  pathname: string;
}) {
  const loaded = useRef(false);
  useEffect(() => {
    if (!GA_MEASUREMENT_ID || loaded.current) return;
    loaded.current = true;
    window.dataLayer = window.dataLayer || [];
    // gtag.js only recognises the native `arguments` object on the dataLayer;
    // pushing a plain array is silently ignored and nothing is ever sent.
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: false
    });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }, []);
  useEffect(() => {
    if (!GA_MEASUREMENT_ID || !window.gtag) return;
    window.gtag('event', 'page_view', {
      page_path: pathname,
      // The real address, so editor and preview visits don't pose as meetsynthia.ai traffic.
      page_location: `${window.location.origin}${pathname}`,
      page_title: document.title
    });
  }, [pathname]);
  return null;
}